"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeywordSetSchema = exports.SearchIntentSchema = exports.ProductPageSchema = void 0;
exports.findKeywordCannibal = findKeywordCannibal;
const zod_1 = require("zod");
const tier_1 = require("./tier");
/**
 * Product Page Registry — PRS §3.
 * Danh sách cố định các page sản phẩm, mỗi sản phẩm một page trong repo s-solution.
 */
exports.ProductPageSchema = zod_1.z.object({
    /** Mã sản phẩm, vd `swingpass` */
    code: zod_1.z.string().min(1),
    slug: zod_1.z.string().regex(/^[a-z0-9-]+$/, 'slug chỉ gồm a-z, 0-9 và dấu gạch ngang'),
    /** Đường dẫn file trong repo s-solution, vd `swingpass/index.html` */
    filePath: zod_1.z.string().min(1),
    publicUrl: zod_1.z.string().url(),
    /** User id người phụ trách page */
    ownerId: zod_1.z.number().int().positive(),
    primaryKeyword: zod_1.z.string().nullable(),
    lastSeoScore: zod_1.z.number().min(0).max(100).nullable(),
    lastScannedAt: zod_1.z.coerce.date().nullable(),
    pendingChangeCount: zod_1.z.number().int().min(0),
    autopilotMode: tier_1.AutopilotModeSchema,
});
/** Search intent — PRS §7. */
exports.SearchIntentSchema = zod_1.z.enum(['informational', 'commercial', 'transactional']);
exports.KeywordSetSchema = zod_1.z.object({
    primary: zod_1.z.string().min(1),
    secondary: zod_1.z.array(zod_1.z.string()).default([]),
    longTail: zod_1.z.array(zod_1.z.string()).default([]),
    semantic: zod_1.z.array(zod_1.z.string()).default([]),
    intent: zod_1.z.array(exports.SearchIntentSchema).default([]),
});
/**
 * Chống ăn thịt từ khoá — PRS §7.
 * Trả về slug của page đang giữ keyword đó, hoặc null nếu chưa ai chiếm.
 */
function findKeywordCannibal(keyword, pages, excludeSlug) {
    const target = keyword.trim().toLowerCase();
    const hit = pages.find((p) => p.slug !== excludeSlug && p.primaryKeyword?.trim().toLowerCase() === target);
    return hit?.slug ?? null;
}
//# sourceMappingURL=registry.js.map